import React from "react"
import styled from "styled-components"
import { Wrapper } from "../../components/templates/wrapper"
import store from "../../config/configureStore"
import { doLogout } from "../../actions/loginDataActionCreator"
import { History } from "history"

export default class LogoutIndex extends React.Component<{ history: History }> {
  private timerId: number
  // TODO エラーページのレンダリング
  public componentDidMount() {
    store.dispatch(doLogout())
    this.timerId = setTimeout(() => {
      this.props.history.push("/")
    }, 5000)
  }

  public componentWillUnmount(): void {
    clearTimeout(this.timerId)
  }

  public render() {
    return (
      <StyledWrapper>
        <h1>ログアウトしました</h1>
        <div>5秒後にトップページに移動します</div>
      </StyledWrapper>
    )
  }
}

const StyledWrapper = styled(Wrapper)`
  padding-top: 20vh;
  padding-bottom: 20vh;
`
